(ns hai.journal2.fuzzy-search
  "Thin wrapper around fuse.js for client-side fuzzy filtering.
  Single point of change if we swap the search library later."
  (:require ["fuse.js" :as Fuse]
            [clojure.string :as str]))

(defn fuzzy-filter
  "Returns items filtered by query using fuse.js fuzzy matching.
  When query is blank, returns items unchanged.

  opts:
    :keys      - vector of string key names for map items, nil for string items
    :threshold - 0.0 (exact) to 1.0 (match anything), default 0.4"
  [items query {:keys [keys threshold] :or {threshold 0.4}}]
  (if (str/blank? query)
    items
    (let [items-v  (vec items)
          js-items (to-array
                    (map-indexed
                     (fn [i item]
                       (let [obj (if (map? item) (clj->js item) #js {:value item})]
                         (aset obj "__idx" i)
                         obj))
                     items-v))
          opts     (cond-> #js {:threshold threshold :includeScore true}
                     keys       (doto (aset "keys" (to-array keys)))
                     (not keys) (doto (aset "keys" #js ["value"])))
          results  (.search (Fuse. js-items opts) query)]
      (mapv #(nth items-v (aget (.-item %) "__idx")) results))))
